module.exports = __webpack_public_path__ + "img/element_4.bef417f9.png";